import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.benutzer-einstellungen-admin';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerEinstellungenAdminEffects {

    BenutzerEinstellungenAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_BENUTZER_EINSTELLUNGEN_ADMIN),
        mergeMap((x: ac.GetBenutzerEinstellungenAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getBenutzerEinstellungenAdmin(x.benutzer_id).pipe(
                map((result: any) => {
                    return new ac.GetBenutzerEinstellungenAdminErfolgreichAction(result, x.benutzer_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetBenutzerEinstellungenAdminFehlerAction(error, x.benutzer_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerEinstellungenAdminQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerEinstellungenAdminQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerEinstellungenAdminQueryService);
        }
        return this.service;
    }
}
